import React from "react";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function CTASection() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      style={{ marginTop: "55px", marginBottom: "40px" }}
    >
      <MKBox
        component="section"
        py={{ xs: 6, md: 8 }}
        px={{ xs: 2, md: 6 }}
        sx={{
          background: "linear-gradient(135deg, #1F2937 0%, #275db4ff 100%)",
          borderRadius: "2rem",
          boxShadow: "0 12px 30px rgba(0,0,0,0.3)",
          color: "#fff",
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={4} lg={5} sx={{ textAlign: { xs: "center", md: "center" } }}>
            <Link to="/employer" style={{ textDecoration: "none" }}>
              <MKButton
                variant="gradient"
                color="white"
                size="large"
                sx={{
                  borderRadius: "1.5rem",
                  px: 5,
                  py: 1.5,
                  fontWeight: "medium",
                  textTransform: "capitalize",
                  color: "#1F2937",
                  boxShadow: "0 4px 20px rgba(255,255,255,0.3)",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 30px rgba(255,255,255,0.35)",
                  },
                }}
              >
                Book Now
              </MKButton>
            </Link>
          </Grid>

          <Grid item xs={12} md={8} lg={7}>
            <MKTypography
              variant="h5"
              fontWeight="bold"
              color="white"
              sx={{
                lineHeight: 1.5,
                textAlign: { xs: "center", md: "right" },
              }}
            >
              Avoid unnecessary stress and uncertainty — we are here to support you in making your
              stay smooth, enjoyable, and free from unpleasant surprises.
            </MKTypography>
          </Grid>
        </Grid>
      </MKBox>
    </motion.div>
  );
}

export default CTASection;
